import { makeApiRequests } from '../../helpers/api';

// Existing work-order forms use the same narrow permission and concurrency check.
export function saveServiceWorkOrder(contract, rows) {
  return makeApiRequests({
    endpoint: '/service-work-orders/' + contract._id,
    method: 'PUT',
    requestBody: {
      serviceOrderReport: rows,
      previousReport: contract.serviceOrderReport == null ? null : contract.serviceOrderReport
    }
  });
}
